import React, { useState } from "react";
import {
    Box,
    Typography,
    Button,
    Card,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SendIcon from "@material-ui/icons/Send";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
import CloseIcon from "@material-ui/icons/Close";
import RoomIcon from "@material-ui/icons/Room";
import CancelIcon from "@material-ui/icons/Cancel";

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: "100vh",
        background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: theme.spacing(2),
        position: "relative",
        overflow: "hidden",
        "&::before": {
            content: '""',
            position: "absolute",
            top: "-50%",
            right: "-10%",
            width: "500px",
            height: "500px",
            background: "rgba(255, 255, 255, 0.1)",
            borderRadius: "50%",
            animation: "$float 6s ease-in-out infinite",
        },
        "&::after": {
            content: '""',
            position: "absolute",
            bottom: "-30%",
            left: "-5%",
            width: "400px",
            height: "400px",
            background: "rgba(255, 255, 255, 0.05)",
            borderRadius: "50%",
            animation: "$float 8s ease-in-out infinite reverse",
        },
    },
    "@keyframes float": {
        "0%, 100%": {
            transform: "translateY(0px)",
        },
        "50%": {
            transform: "translateY(30px)",
        },
    },
    container: {
        maxWidth: "550px",
        width: "100%",
        zIndex: 10,
    },
    card: {
        borderRadius: "16px",
        // boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
        padding: theme.spacing(4),
        background: "#f3f4f6",
        border: "none",
        boxShadow: "none",
    },
    dialogPaper: {
        borderRadius: "10px",
        maxWidth: "900px",
        width: "100%",
        margin: theme.spacing(1),
    },
    modalHeader: {
        background: "linear-gradient(135deg, #111a3c 0%, #1a2448 100%)",
        color: "#fff",
        minHeight: 56,
        padding: theme.spacing(1.2, 2.5),
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    modalTitleWrap: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
    },
    modalTitle: {
        color: "#fff",
        fontSize: "1rem",
        fontWeight: 500,
    },
    modalCloseBtn: {
        color: "#fff",
        padding: 6,
    },
    modalBody: {
        background: "#f3f4f6",
        padding: theme.spacing(4),
    },
    modalFooter: {
        background: "#f3f4f6",
        borderTop: "1px solid #d8d8d8",
        padding: theme.spacing(2, 3),
        display: "flex",
        justifyContent: "flex-end",
    },
    cancelButton: {
        border: "1px solid #f97373",
        color: "#f44336",
        borderRadius: "24px",
        textTransform: "none",
        fontWeight: 600,
        padding: theme.spacing(0.8, 2.5),
        backgroundColor: "#fff",
    },
    header: {
        textAlign: "center",
        marginBottom: theme.spacing(3),
    },
    iconContainer: {
        width: 70,
        height: 70,
        borderRadius: "14px",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto",
        marginBottom: theme.spacing(1.5),
    },
    title: {
        fontSize: "2.2rem",
        fontWeight: 700,
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        marginBottom: theme.spacing(0.5),
        fontFamily: "'Poppins', sans-serif",
    },
    subtitle: {
        fontSize: "0.95rem",
        color: "#666",
        fontFamily: "'Poppins', sans-serif",
    },
    detailsSection: {
        marginBottom: 0,
        padding: theme.spacing(3),
        background: "#e9eaec",
        borderRadius: "12px",
        border: "1px solid #e0e0e0",
        textAlign: "center",
    },
    detailItem: {
        marginBottom: theme.spacing(2.5),
        "&:last-child": {
            marginBottom: 0,
        },
    },
    detailLabel: {
        fontSize: "0.85rem",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "1.2px",
        color: "#764ba2",
        marginBottom: theme.spacing(0.5),
        fontFamily: "'Poppins', sans-serif",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: theme.spacing(1),
    },
    detailText: {
        fontSize: "1.05rem",
        color: "#333",
        fontWeight: 500,
        lineHeight: 1.6,
        fontFamily: "'Poppins', sans-serif",
        wordBreak: "break-word",
        cursor: "pointer",
        transition: "all 0.3s ease",
        padding: theme.spacing(1),
        borderRadius: "8px",
        "&:hover": {
            color: "#667eea",
            backgroundColor: "rgba(102, 126, 234, 0.1)",
            transform: "scale(1.02)",
        },
    },
    buttonContainer: {
        display: "flex",
        justifyContent: "center",
        gap: theme.spacing(2),
        marginBottom: theme.spacing(3),
    },
    createButton: {
        background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
        color: "white",
        fontWeight: 600,
        textTransform: "none",
        fontSize: "1.1rem",
        padding: theme.spacing(1.5, 3),
        borderRadius: "10px",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        fontFamily: "'Poppins', sans-serif",
        border: "none",
        cursor: "pointer",
        boxShadow: "0 6px 20px rgba(102, 126, 234, 0.4)",
        "&:hover": {
            transform: "translateY(-3px)",
            boxShadow: "0 10px 30px rgba(102, 126, 234, 0.6)",
        },
        "&:active": {
            transform: "translateY(0px)",
        },
    },
    supportInfo: {
        marginTop: theme.spacing(3),
        padding: theme.spacing(2),
        background:
            "linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%)",
        borderRadius: "10px",
        border: "1px solid rgba(102, 126, 234, 0.2)",
        textAlign: "center",
    },
    supportText: {
        fontSize: "0.9rem",
        color: "#666",
        fontFamily: "'Poppins', sans-serif",
        lineHeight: 1.5,
    },
}));

function CreateTickets({ open, onClose }) {
    const classes = useStyles();
    const [activeContact, setActiveContact] = useState(null);
    // Get user data from session storage
    const email = localStorage.getItem("email") || "";
    // const email = "nitesh.yadav@watsoo.com"

    // Checking user first exist or not
    // const handleCreateTicket = async () => {
    //     if (!email) {
    //       alert("Email not found");
    //       return;
    //     }
    //     try {
    //       const res = await axios.post(
    //         "https://support.watsoo.com/backend/auth/login",
    //         {
    //           username: email,
    //           companyToken: "AISWATSOO",
    //         },
    //       );

    //       if (res.status === 200) {
    //         const Url = `http://support.watsoo.com/sso?companyToken=${encodeURIComponent(
    //           "AISWATSOO",
    //         )}&username=${encodeURIComponent(email)}`;
    //         window.open(Url, "_blank");
    //       } else {
    //         alert("User not found on support portal, Contact Admin");
    //       }
    //     } catch (error) {
    //       console.error(error);
    //       alert("Something went wrong");
    //     }
    //   };
    const handleCreateTicket = () => {
        const Url = `http://support.watsoo.com/sso?companyToken=${encodeURIComponent(
            "AISWATSOO"
        )}&username=${encodeURIComponent(
            email
        )}`;
        window.open(Url, "_blank");
    };

    const handleEmailClick = () => {
        setActiveContact("email");
        setTimeout(() => {
            window.open(`mailto:${"support.watsoo.com"}`, "_blank");
        }, 300);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            PaperProps={{ className: classes.dialogPaper }}
        >
            <DialogTitle disableTypography className={classes.modalHeader}>
                <Box className={classes.modalTitleWrap}>
                    <RoomIcon style={{ fontSize: "24px" }} />
                    <Typography className={classes.modalTitle}>Raise An Issue</Typography>
                </Box>
                <IconButton className={classes.modalCloseBtn} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className={classes.modalBody}>
                <Card className={classes.card} elevation={0}>
                    {/* Header with Button */}
                    <Box className={classes.header}>
                        <Box className={classes.buttonContainer}>
                            <Button
                                className={classes.createButton}
                                startIcon={<SendIcon />}
                                onClick={handleCreateTicket}
                            >
                                Create Ticket Now
                            </Button>
                        </Box>
                    </Box>

                    {/* User Details Section - Centered */}
                    <Box className={classes.detailsSection}>
                        {/* Email Detail */}
                        <Box className={classes.detailItem}>
                            <Typography className={classes.detailLabel}>
                                <EmailIcon style={{ fontSize: "25px" }} />
                                Email Address
                            </Typography>
                            <Typography
                                className={classes.detailText}
                                //
                                style={{
                                    backgroundColor:
                                        activeContact === "email"
                                            ? "rgba(102, 126, 234, 0.2)"
                                            : "transparent",
                                    fontWeight: "bold",
                                }}
                            >
                                <span onClick={handleEmailClick}>
                                    {"support.watsoo.com"}
                                </span>
                            </Typography>
                            {/* <Typography
                style={{
                  fontSize: "0.8rem",
                  color: "#999",
                  marginTop: "4px",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                Click to send email
              </Typography> */}
                        </Box>

                        {/* Phone Detail */}
                        {/* <Box className={classes.detailItem}>
              <Typography className={classes.detailLabel}>
                <PhoneIcon style={{ fontSize: "20px" }} />
                Phone Number
              </Typography>
              <Typography
                className={classes.detailText}
                onClick={handlePhoneClick}
                style={{
                  backgroundColor:
                    activeContact === "phone"
                      ? "rgba(118, 75, 162, 0.2)"
                      : "transparent",
                }}
              >
                {mobileNumber}
              </Typography>
            </Box> */}
                    </Box>
                </Card>
            </DialogContent>
            <DialogActions className={classes.modalFooter}>
                <Button
                    className={classes.cancelButton}
                    startIcon={<CancelIcon style={{ fontSize: "18px" }} />}
                    onClick={onClose}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default CreateTickets;